import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: "Home", path: "/" },
    { name: "End of Tenancy", path: "/end-of-tenancy" },
    { name: "Commercial", path: "/commercial" },
    { name: "Residential", path: "/residential" },
    { name: "Locksmith", path: "/locksmith" },
    { name: "Handyman", path: "/handyman" },
    { name: "More Services", path: "/additional-services" },
    { name: "Gallery", path: "/gallery" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-gray-200">
      {/* Diagonal accent line */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-400 via-navy-800 to-cyan-400"></div>

      <nav className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <div>
              <img
                src="/logo.png"
                alt="Shiny Crew Cleaning"
                className="h-16 w-auto"
              />
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative px-4 py-2 text-sm font-semibold ${
                  isActive(item.path)
                    ? "text-cyan-500"
                    : "text-gray-700 hover:text-navy-900"
                }`}
              >
                {item.name}
                {isActive(item.path) && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-cyan-400" />
                )}
              </Link>
            ))}
            <Link to="/get-quote">
              <button className="ml-6 px-6 py-3 bg-navy-900 text-white font-bold text-sm rounded-lg hover:bg-navy-800 relative overflow-hidden group">
                <span className="relative z-10">GET A QUOTE</span>
              </button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden w-10 h-10 flex flex-col items-center justify-center space-y-1.5"
          >
            <span
              className={`w-6 h-0.5 bg-navy-900 block ${isOpen ? "rotate-45 translate-y-2" : ""}`}
            ></span>
            <span
              className={`w-6 h-0.5 bg-navy-900 block ${isOpen ? "opacity-0" : ""}`}
            ></span>
            <span
              className={`w-6 h-0.5 bg-navy-900 block ${isOpen ? "-rotate-45 -translate-y-2" : ""}`}
            ></span>
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:hidden overflow-hidden">
            <div className="py-4 space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`block px-4 py-3 text-base font-semibold rounded-lg ${
                    isActive(item.path)
                      ? "bg-cyan-50 text-cyan-600"
                      : "text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/get-quote"
                onClick={() => setIsOpen(false)}
                className="block w-full mt-4 px-6 py-3 bg-navy-900 text-white font-bold text-sm rounded-lg text-center hover:bg-navy-800"
              >
                GET A QUOTE
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
